import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog } from '@angular/material';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { Parameter, FundParameters, PeriodTypeEnum, Employee } from '@akiba/models_bimbo';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-ps-details',
  templateUrl: './ps-details.component.html',
  styleUrls: ['./ps-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PsDetailsComponent implements OnInit {

  //////////////////////////////////////
  permanentSavingParameter: Parameter | null = null;
  shortFundParameter: FundParameters | null = null;
  longFundParameter: FundParameters | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  //////////////////////////////////////

  @Input() contentLocation: AppState;
  withdrawDisabledReason = '';
  modificationDisabledReason = '';
  cancellationDisabledReason = '';
  reInscriptionDisabledReason = '';
  loanAmountListPending: number = 0;
  savingsTotalEnabled: number = 0;

  constructor(public logicService: LogicService, private authService: AuthenticationService, private dialog: MatDialog, private dataService: DataSourceService) {

    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;
    const fundParameters = this.logicService.dataManager.parameterDataLoader.fundParameters;
    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];
    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
    this.shortFundParameter = fundParameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.shortSavingFund).find(e => e.fundAppliesTo(this.currentEmployee));
    this.longFundParameter = fundParameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.longSavingFund).find(e => e.fundAppliesTo(this.currentEmployee));
    if (this.currentEmployee.permanentSavings) {
      this.savingsTotalEnabled = Number(((this.currentEmployee.permanentSavings.total + this.currentEmployee.permanentSavings.totalExtras) - this.currentEmployee.permanentSavings.totalWithdrawals).toFixed(2));
    }
    this.loanPending();

  }

  ngOnInit() {
    if (this.shouldShowContributions) {
      this.contentLocation.contentIndex = 0;
    } else{
    this.contentLocation.contentIndex = 4;
    }

  }

  get visiblePermanent(): boolean {
    let res: boolean = false;

    if (this.currentEmployee.permanentSavings) {
      if (this.permanentSavingParameter && this.permanentSavingParameter.savingParameter) {
        if ((this.permanentSavingParameter.isRegistrationDateAllowed || this.permanentSavingParameter.isWithdrawDateAllowed)) {
          res = true;
        }else if ((this.permanentSavingParameter.isRegistrationDateAllowed || this.permanentSavingParameter.isWithdrawDateAllowed) === false && this.savingsTotalEnabled > 0 ){
          res = true;
        }
      }
      if (this.authService.appLevel.administrator) {
        res = true;
      }
    }
    return res;
  }

  switchTo(anIndex: number) {

    this.contentLocation.contentIndex = anIndex;

    if (anIndex === 2) {

      if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan.status != "review" && this.currentEmployee.permanentSavingsLoan.status != "active_pending") {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'Tiene un préstamo pendiente con la caja de ahorro, el monto a retirar sera usado<br>parcialmente para liquidar el préstamo',
            close: 'Aceptar'
          }
        });

      }

    }

  }

  get shouldEnableSavingsModification(): boolean {

    if (this.currentEmployee.permanentSavings.status === 'canceled') {
      this.modificationDisabledReason = 'No es posible modificar las cuotas ya que la caja ha sido cancelada.';
      return false;
    }

    /** validacion si no es administrador */
    if (!this.authService.appLevel.administrator) {

      if (this.logicService.isTodayAPayrollDayForEmployee(this.currentEmployee)) {
        this.modificationDisabledReason = 'En este momento no es posible la modificación de la suscripción debido a que existe un periodo de pago activo';
        return false;
      }

      if (this.permanentSavingParameter) {

        if (!this.permanentSavingParameter.isRegistrationDateAllowed) {

          this.modificationDisabledReason = 'En este momento no es posible la modificación de la suscripción ya que esta fuera del periodo.';
          return false;

        }


      } else {
        this.modificationDisabledReason = 'En este momento no es posible la modificación de la suscripción ya que esta fuera del periodo de registro';
        return false;
      }
    }
    return true;

  }

  get shouldEnableSavingsCancellation(): boolean {

    if (this.currentEmployee.permanentSavings.status === 'canceled') {
      this.cancellationDisabledReason = 'No es posible modificar las cuotas ya que la caja ha sido cancelada.';
      return false;
    }

    /** validacion si no es administrador */
    if (!this.authService.appLevel.administrator) {

      if (this.logicService.isTodayAPayrollDayForEmployee(this.currentEmployee)) {
        this.cancellationDisabledReason = 'En este momento no es posible la cancelación de la suscripción debido a que existe un periodo de pago activo';
        return false;
      }

      if (this.permanentSavingParameter) {

        if (!this.permanentSavingParameter.isRegistrationDateAllowed) {

          this.cancellationDisabledReason = 'En este momento no es posible la cancelación de la suscripción ya que esta fuera del periodo.';
          return false;

        }
      } else {
        this.cancellationDisabledReason = 'En este momento no es posible la cancelación de la suscripción ya que esta fuera del periodo de registro';
        return false;
      }
    }
    return true;

  }

  /**
 * funcion para regresar el prestamo activo en colaboradores en lista de espera
 */
  async loanActiveInListPending() {
    const loans = await this.dataService.loadLoanActiveListPending(this.currentEmployee.workInformation.employeeNumber, 500, 500);
    let restructuredID: string = '';
    let loanFalse = [];
    let activePending: boolean;
    let arrayActive: Array<any> = [];
    let activePendingList: Array<any> = [];
    let sumaPaids: number = 0;
    activePendingList = loans.filter(e => e.active === true && e.type === 'permanent' && (e.status == 'active_pending' || e.status == 'review'));

    if (loans.length > 1 && activePendingList.length > 0) {

      const loanListPending = loans.filter(e => e.active === true && e.type === 'permanent' && (e.status != 'active_pending' || e.status != 'review'));
      //const loanListCaducado = loans.filter(e => e.active === false && e.type === 'permanent' && (e.status != 'active_pending' || e.status != 'review'));

      if (loanListPending.length > 0) {
        loanListPending.map(e => restructuredID = e.restructuredID);
        /* if (restructuredID == '') {
            loanListCaducado.forEach(e => {
              if (e.comment !== 'Rechazo automático por falta de aprobación.' && (e.status === 'caducado' || e.status === 'active')) {
                let app = e.createdAt.toDate();
                arrayActive.push({ loanID: e.loanID, approvedAt: app.getTime() });
              }
            });
            arrayActive.sort(function (a, b) {
              return b.approvedAt - a.approvedAt;
            });
  
            arrayActive.map(e => restructuredID = e.loanID);
          }*/
      }
    }

    if (restructuredID != '') {
      const loadLoan: any = await this.dataService.loadLoan(restructuredID).pipe(take(1)).toPromise().catch(error => {
        console.log(error);
        return [];
      });

      if (loadLoan.status != 'paid' && loadLoan.status != 'withdraw') {
        const cretedAt = loadLoan.createdAt.toDate();
        const interestType = loadLoan.interestType;
        const suma = await this.dataService.loanActiveInPendingList(this.currentEmployee.workInformation.employeeNumber, cretedAt, interestType);

        suma.map(e => {
          sumaPaids = loadLoan.requestedAmount - e.sumPayments
        });
      }

    }

    return sumaPaids;
  }

  async loanPending() {
    this.loanAmountListPending = await this.loanActiveInListPending();
  }


  get shouldEnableSavingsWithdraw(): boolean {

    if (!this.currentEmployee.permanentSavings) {
      return false;
    }

    if (this.permanentSavingParameter) {
      // start user admin
      if (this.authService.appLevel.administrator) {

        if (this.currentEmployee.permanentSavings.withdraws) {
          const pendingWithdraw = this.currentEmployee.permanentSavings.withdraws.values().find(element => element.active);
          const now = new Date().getTime();
          if (pendingWithdraw !== undefined) {
            let pendingWithdrawDate = pendingWithdraw.withdrawID !== undefined ? parseInt(pendingWithdraw.withdrawID) : 0;
            let datePendingWithdraw = pendingWithdrawDate + (60000 * 30);//getTime devuelve milisegundos de esa fecha

            if (datePendingWithdraw > now) {
              this.withdrawDisabledReason = 'En este momento tiene una solicitud de retiro en proceso de deposito, no es posible solicitar otro retiro en este periodo.';
              return false;
            }
          }
        }

        if (this.currentEmployee.permanentSavings.total < 1) {
          this.withdrawDisabledReason = 'El saldo de la caja esta en ceros.';
          return false;
        }

        if (this.loanAmountListPending > 0) {
          const permanentSavingsEmployeeTotal = this.currentEmployee.permanentSavings.total;
          const permanentSavingsExtrasTotal = this.currentEmployee.permanentSavings.totalExtras;
          const permanentSavingsWithdrawalsTotal = this.currentEmployee.permanentSavings.totalWithdrawals;
          const permanentSavingsTotal = (permanentSavingsEmployeeTotal + permanentSavingsExtrasTotal) - permanentSavingsWithdrawalsTotal;

          if (this.loanAmountListPending > permanentSavingsTotal) {
            this.withdrawDisabledReason = 'El monto del préstamos es mayor al saldo total ahorrado (sin tener en cuenta el rendimiento), de acuerdo al reglamento punto 9';
            return false;
          }
        }

        if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan.status != "review" && this.currentEmployee.permanentSavingsLoan.status != "active_pending") {
          const loan = this.currentEmployee.permanentSavingsLoan;
          const loanTotal = loan.scheduleDates.values().filter(element => element.paid === false).map(element => element.capital).reduce(((prev, next) => prev + next), 0);
          const permanentSavingsEmployeeTotal = this.currentEmployee.permanentSavings.total;
          const permanentSavingsExtrasTotal = this.currentEmployee.permanentSavings.totalExtras;
          const permanentSavingsWithdrawalsTotal = this.currentEmployee.permanentSavings.totalWithdrawals;
          const permanentSavingsTotal = (permanentSavingsEmployeeTotal + permanentSavingsExtrasTotal) - permanentSavingsWithdrawalsTotal;

          if (loanTotal > permanentSavingsTotal) {
            this.withdrawDisabledReason = 'El monto del préstamos es mayor al saldo total ahorrado (sin tener en cuenta el rendimiento), de acuerdo al reglamento punto 9';
            return false;
          }
        }
        // end user admin

      } else {
        // start user not admin
        if (!this.permanentSavingParameter.isWithdrawDateAllowed) {

          this.withdrawDisabledReason = 'En este momento no es posible la modificación de la suscripción ya que esta fuera del periodo.';
          return false;

        } else {
          const w = this.currentEmployee.permanentSavings.withdraws.values();
          const wy = this.currentEmployee.permanentSavings.withdrawsInYear;
          const now = new Date();
          const year = now.getFullYear().toString();
          if (wy.hasOwnProperty(year)) {

            const count = wy[year];
            /* if (count > 1) {
               this.withdrawDisabledReason = 'No es posible retirar mas de dos veces al año.';
               return false;
             } else if (count === 1) {*/

            const current = this.permanentSavingParameter.savingParameter.withdrawDates.find(cd => {
              if (cd.active) {
                if (cd.endDate) {
                  return cd.endDate >= now && cd.startDate <= now;
                } else {
                  return cd.startDate <= now;
                }
              }
            });

            if (current !== undefined) {
              const wd = w.find(e => {
                return current.endDate >= e.date && current.startDate <= e.date && e.active === true;
              });

              if (wd !== undefined) {
                this.withdrawDisabledReason = 'No es posible retirar mas de una vez en el mismo periodo.';
                return false;
              }
            }

            //  }

          }

          if (this.currentEmployee.permanentSavings.withdraws) {
            const pendingWithdraw = this.currentEmployee.permanentSavings.withdraws.values().find(element => element.active);
            if (pendingWithdraw !== undefined) {
              this.withdrawDisabledReason = 'En este momento tiene una solicitud de retiro en proceso de deposito, no es posible solicitar otro retiro en este periodo.';
              return false;
            }
          }

          if (this.logicService.isTodayAPayrollDayForEmployee(this.currentEmployee)) {
            this.withdrawDisabledReason = 'En este momento no es posible la modificación de cuotas debido a que existe un periodo de pago activo.';
            return false;
          }

          //this.currentEmployee.permanentSavings.total
          
          if (this.savingsTotalEnabled < 1) {
            this.withdrawDisabledReason = 'El saldo de la caja esta en ceros.';  
            return false;
          }

          if (this.loanAmountListPending > 0) {
            const permanentSavingsEmployeeTotal = this.currentEmployee.permanentSavings.total;
            const permanentSavingsExtrasTotal = this.currentEmployee.permanentSavings.totalExtras;
            const permanentSavingsWithdrawalsTotal = this.currentEmployee.permanentSavings.totalWithdrawals;
            const permanentSavingsTotal = (permanentSavingsEmployeeTotal + permanentSavingsExtrasTotal) - permanentSavingsWithdrawalsTotal;

            if (this.loanAmountListPending > permanentSavingsTotal) {
              this.withdrawDisabledReason = 'El monto del préstamos es mayor al saldo total ahorrado (sin tener en cuenta el rendimiento), de acuerdo al reglamento punto 9';
              return false;
            }
          }

          if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan.status != "review" && this.currentEmployee.permanentSavingsLoan.status != "active_pending") {
            const loan = this.currentEmployee.permanentSavingsLoan;
            const loanTotal = loan.scheduleDates.values().filter(element => element.paid === false).map(element => element.capital).reduce(((prev, next) => prev + next), 0);
            const permanentSavingsEmployeeTotal = this.currentEmployee.permanentSavings.total;
            const permanentSavingsExtrasTotal = this.currentEmployee.permanentSavings.totalExtras;
            const permanentSavingsWithdrawalsTotal = this.currentEmployee.permanentSavings.totalWithdrawals;
            const permanentSavingsTotal = (permanentSavingsEmployeeTotal + permanentSavingsExtrasTotal) - permanentSavingsWithdrawalsTotal;

            if (loanTotal > permanentSavingsTotal) {
              this.withdrawDisabledReason = 'El monto del préstamos es mayor al saldo total ahorrado (sin tener en cuenta el rendimiento), de acuerdo al reglamento punto 9';
              return false;
            }
          }

        }
      }

    } else {
      if (this.authService.appLevel.administrator) {
        return true;
      }
      this.withdrawDisabledReason = 'En este momento no es posible el retiro ya que esta fuera del periodo';
      return false;
    }

    return true;

  }

  get shouldShowContributions(): boolean {

    if (this.currentEmployee.permanentSavings && this.currentEmployee.permanentSavings.status === 'active' && this.savingsTotalEnabled > 0) {
      return true;
    } else {
      return false;
    }

  }

  get shouldShowSavingsRegistration(): boolean {

    return this.currentEmployee.permanentSavings.status === 'canceled';

  }

  get shouldEnableSavingsRegistration(): boolean {

    /** validacion si no es administrador */
    if (!this.authService.appLevel.administrator) {

      if (this.logicService.isTodayAPayrollDayForEmployee(this.currentEmployee)) {
        this.reInscriptionDisabledReason = 'En este momento no es posible la reinscripción debido a que existe un periodo de pago activo';
        return false;
      }

      if (this.permanentSavingParameter) {

        if (!this.permanentSavingParameter.isRegistrationDateAllowed) {

          this.reInscriptionDisabledReason = 'En este momento no es posible la reinscripción ya que esta fuera del periodo.';
          return false;

        }

      } else {
        this.reInscriptionDisabledReason = 'En este momento no es posible la reinscripción ya que esta fuera del periodo de registro';
        return false;
      }
    }

    return true;

  }

}
